window._ = require('lodash');
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
    require('admin-lte');
} catch (e) {
    console.log(e);
}
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
const $ = require('jquery')
// Lo declaramos globalmente
window.$ = $
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
const wsScheme = process.env.MIX_REVERB_SCHEME || process.env.MIX_WS_SCHEME || 'http';
const configuredWsHost = process.env.MIX_REVERB_HOST || process.env.MIX_WS_HOST || process.env.MIX_DOMAIN || 'localhost';
// 0.0.0.0 is a server bind address, not a host browsers can connect to.
const wsHost = ['0.0.0.0', '::'].includes(configuredWsHost)
    ? window.location.hostname
    : configuredWsHost;
const wsPort = process.env.MIX_REVERB_PORT || process.env.MIX_WS_PORT || 8080;
const wsKey = process.env.MIX_REVERB_APP_KEY || process.env.MIX_PUSHER_APP_KEY;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: wsKey,
    wsHost: wsHost,
    wsPort: wsPort,
    wssPort: wsPort,
    forceTLS: wsScheme === 'https',
    disableStats: true,
    enabledTransports: ['ws', 'wss']
});
